import type {
  ScenarioResultKey,
  ScenarioStoryDefinition,
  StoryEntry,
} from "../../shared/index.js";

const STORY_TURN_COUNT = 6;

export function buildStoryPrelude(
  story: ScenarioStoryDefinition,
): readonly StoryEntry[] {
  return [
    ...story.opening,
    ...(story.beforeTurn[1] ?? []),
  ];
}

export function buildStoryEpilogue(
  story: ScenarioStoryDefinition,
  resultKey: ScenarioResultKey,
  turnFourResonated: boolean | null,
): readonly StoryEntry[] {
  const sequence: StoryEntry[] = [];

  for (let turn = 1; turn <= STORY_TURN_COUNT; turn += 1) {
    sequence.push(...(story.afterTurn[turn] ?? []));
    if (turn === 4 && turnFourResonated !== null) {
      sequence.push(...(
        turnFourResonated
          ? story.resonanceResult.resonance
          : story.resonanceResult.split
      ));
    }
    if (turn < STORY_TURN_COUNT) {
      sequence.push(...(story.beforeTurn[turn + 1] ?? []));
    }
  }

  sequence.push(
    ...story.resultScenes[resultKey],
    ...story.resultCommon,
    ...story.closing,
    ...story.postscriptOpening,
    ...story.postscriptScenes[resultKey],
    ...story.postscriptCommon,
  );
  return sequence;
}

export function isStorySuccess(resultKey: ScenarioResultKey): boolean {
  return resultKey === "ideal";
}
